import React, { FC } from 'react';
import styles from './decision_separator.module.scss';

export const DecisionSeparator: FC = () => (
  <span className={styles.separator}>·</span>
);
